import './flexible.js'

import Req from './Fetch'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Message from './Utils/Message'
import {getAllUrlParams, json2keyval, refreshPage, getQueryString, openKf} from './Utils/Utils'
import { getBaseConfig } from './Base'
import history from './History';
import LC from "@kugou/light-mobilecall";
import openKugouApp from "@kugou/open-kugou-app"
import kgLoad from "@kugou/kg-loading" 
import './commons.scss'

import './BI.js'

// import history from './History'
import e from './Utils/Event'
import kgStatObj from "@kugou/stat";
const { notifyToStartReporting } = kgStatObj;

e.on('loading', config => {
  let loading;
  let text = ''
  if (typeof config === 'object') {
    loading = config.loading
    text = config.text
  } else {
    loading = config
  }
  if(loading){
    LC.mobileCall(122, null, (res)=>{
      if (typeof res != 'undefined') {
        try {
          res = JSON.parse(res);
        } catch (error) { }
        if(res && res.function_module && res.function_module.useNativeLoading === 1){
          return
        }
        let config = {
          type: 'block',
          ele: document.querySelector("body"),
          autoWarn: false, // 不自动黄菊
          popMode: true, // 弹窗模式
          msg: "正在加载，请稍候",
        }
        if(text){
          config = Object.assign(config, {
            msg: text,
            type: 'toast',
            popConfig: {
              showBg: true,
              containerBgColor: 'default', // default: rgba(0,0,0,0.7)，也可以自定义颜色
              maskBgColor: 'none', // none：无颜色，也可以自定义颜色
            }
          })
        }
        window.loadingEle = kgLoad(config)
      }
    })
  }else{
    window.loadingEle && window.loadingEle.remove && window.loadingEle.remove()
    window.loadingEle = null;
  }
})

window.LC = LC
const mobileCmd = {
  getUserInfo: 101,
  getVersion: 122,
  getMobileInfo: 124,
  login: 102,
  openURL: 123,
  showHideBar: 128,
  closeFrame: 158,
  showRightMenus: 192,
  authMeet: 266,
  setKeyboard: 270,
  updateTitle: 602,
  savePreReturnPage: 710
};

window.$Msg = Message
window.$Text = text => Message(text, 0)

window.$req = Req()
window.$reqT = Req('https://ysit3.tencentmusic.com', { noSign: true })
window.$reqR = Req('https://relationuser.kugou.com')

window.$userInfo = {
  // userid: 1315566113,
  isLogin: false
}

//获取平台的基本用户信息
window.$getUserInfo = function (callback, force) {
  if (window.$userInfo.userid && window.$userInfo.mid && !force) {
    callback && callback(window.$userInfo)
    return
  }
  if (LC.isInClient()) {
    LC.mobileCall(mobileCmd.getUserInfo, null, function (res1) {
      let info = {
        isLogin: Number(res1.status) === 1,
        userid: res1.kugouID,
        appid: res1.appid,
        token: res1.token
      }
      Object.assign(window.$userInfo, res1, info)

      LC.mobileCall(mobileCmd.getMobileInfo, null, function (res2) {
        Object.assign(window.$userInfo, res2)
        window.$userInfo.mid = res2.mid
        window.$userInfo.mid_v2 = res2.mid_v2
        window.$userInfo.uuid = res2.uuid
        LC.mobileCall(mobileCmd.getVersion, null, function (res3) {
          Object.assign(window.$userInfo, res3)
          window.$userInfo.clientver = res3.version
          if (LC.isIOS) {
            window.$userInfo.plat = 2;
          }else{
            window.$userInfo.plat = 1;
          }
          if(process.env.NODE_ENV == 'development'){
            console.log(JSON.stringify(window.$userInfo));
          }
          callback && callback(window.$userInfo)
        })
      })
    });
  } else {
    //取消端外显示个人信息状态
    // var userid = Cookie().read("KuGoo", "KugooID");
    // let userInfo = {}
    // if (userid) {
    //   userInfo.isLogin = true;
    //   var appid = Cookie().read("KuGoo", "a_id");
    //   var token = Cookie().read("KuGoo", "t");
    //   userInfo.userid = userid;
    //   userInfo.appid = appid;
    //   userInfo.token = token;
    // }
    // Object.assign(window.$userInfo, userInfo);

    //调试代码
    // window.$userInfo = {"isLogin":true,"photo":"http://imge.kugou.com/kugouicon/165/20130304/20130304200233769588.jpg","servertime":1672109279000,"appid":"1000","userLabel":{"val7":1073742340,"val4":1073741860,"val1":3159236,"val8":2097152,"val5":8192,"val2":1073807488,"val9":98304,"val6":134217728,"val3":268437504},"musicType":0,"nickName":"辉","mid":"e4333e10dea3b0bf3b56b4a5436f2f747f78b902","status":1,"isVip":0,"uniqid":"RG9O7FCrX+IQIqvgz4W+7p8nDwN35WM6+FsMgfKpcj4","coupon_batch_number":"a76547367b72e3d66ce216beb7ba7afe","token":"h58BF014A2B1B1B19EF3B771A49D1E34DAC8C3EAC7D043D5F767CBBFF80FF50D5C3933F21AF7711B244E2ABCB795646AB2065F2582BF09B14D38DF247F1AC851061DF021C46E96CBC6F267E714AAE94F1E7160A2AEFE225260B04A80B05F41434307E163AE82F38AC66DE6A292591D9D70E0D325174465717964C07DBC5116D2C0","service":3,"clientver":"11399","gradeData":{"p_grade":1,"p_current_point":334,"p_speed_info":{"p0":1,"p3":2.5,"p2":2,"p1":1.5},"d_sec":16065,"duration":267,"p_next_grade":2,"p_grade_point":300,"p_next_grade_point":1000},"dfid":"2lvcZd4Cnd8J2H6rTO1TiUpb","userName":"kgopen52175132","download_coupon_batch_number":"c27466b132849e156b3a441084d90e47","kugouID":"52175132","appkey":"y9tjae~n)k)vn[8","userid":"52175132","sysmodel":"iPhone%2012%20Pro","sim":"","clienttime":"1672109882","version":"11399","channel":"1009","net":"wifi","osVersion":"16.0.2","isLiuHaiScreen":true,"deviceType":"iPhone 12 Pro","appId":"1000","tmd":"030E494814085D06040E055E4E15120E0105560E520E4911415D09010253005D4F42410F1D000500535D4A4744580F000701","phoneNum":"","oaid":"","phonebrand":"iphone","osversion":"16.0.2","function_module":{"is_openTask":0,"pendant_version":2,"set_pic_version":1,"task_ver":2,"open_growth_icon":1,"is_overseas":2,"is_transparency":1,"search_immerse_banner":1,"preload_search_result":1,"support_freemode_config":1,"season_and_year":0,"search_recommend_video_array":1,"jump_type":1,"isUseVipCenter":0,"support_autoFreemode":1,"isSupportUpload":1,"open_growth_icon_v2":0,"isSupportSuperVip":1,"support_gift":1,"vip_grade_free_listen_allowed":1,"commissionmake":1,"is_support_lbook_vip":2,"reading_sqaure":1,"is_support_hide_titlebar":1,"isOpenAd":0,"search_h5_api_version":1},"platform":"ios","pointsExchange":false,"musicPkgFeeV2Toggle":"1","statusColor":"green","fo":"酷狗首页/听首页/导航栏/推荐/创作者平台/酷狗音乐开放平台","plat":2}
    callback && callback(window.$userInfo);
  }
}

function Cookie() {
  return {
    read: function (name, key, isJSON) {
      var cookieValue = "";
      var arrStr = document.cookie.split("; ");
      for (var i = 0; i < arrStr.length; i++) {
        var temp = arrStr[i].match(/^(\w+)=(.+)$/);
        if (temp && temp.length > 1 && temp[1] === name) {
          cookieValue = temp[2];
          break;
        }
      }
      if (key) {
        if (!isJSON) return new this.Param().parse(cookieValue)[key];
        else return JSON.parse(cookieValue)[key];
      }
      return cookieValue;
    },
    Param: function () {
      var o = {};
      this.parse = function (str) {
        var a = str.split("&");
        for (var i = 0, l = a.length; i < l; i++) {
          var k = a[i].split("=");
          o[k[0]] = k[1];
        }
        return o;
      };
    }
  };
}


//初始化先获取个人数据
window.$getUserInfo()

//必须登录拿平台基本信息
window.$mustLogin = function (callback) {
  window.$getUserInfo(res => {
    //console.log(res)
    if (!res.isLogin) {
      callLogin();
    } else {
      callback && callback(res)
    }
  })
}

window.$getMyKugouStarStatus = function(callback, force, failCb){
  if (!force && window.$kugouStarStatus) {
    callback && callback(window.$kugouStarStatus)
    return
  }
  //异步获取酷狗这边的音乐人状态
  window.$getUserInfo(({ userid, token }) => {
    window.$reqR('getMyKugouStarStatus', { userid, token }, { originRes: true }).then(oRes => {
      let res = oRes.data
      if (res.status === 1) {
        let data = res.data;
        window.$kugouStarStatus = data;
        callback && callback( data );
      }
    }).catch(()=>{
      failCb && failCb();
      window.$Msg('网络异常，请稍后再试')
      setTimeout(() => {
        if (LC.isIOS) {
          LC.mobileCall(mobileCmd.closeFrame, { type: 1 })
        } else {
          LC.mobileCall(mobileCmd.closeFrame, { type: 2 })
        }
      }, 1000);
    })
  });
}

window.$getRemixStatus = function(callback, force, failCb){
  if (!force && window.$remixStatus) {
    callback && callback(window.$remixStatus)
    return
  }
  e.emit('loading', true)
  window.$req('remixInfo', {
    biz: 'musician_author_dj',
    userid: window.$userInfo.userid
  }).then(res => {
    e.emit('loading', false)
    window.$remixStatus = res;
    callback(res)
  }).catch(()=>{
    e.emit('loading', false)
    failCb && failCb();
    window.$Msg('网络异常，请稍后再试')
    setTimeout(() => {
      if (LC.isIOS) {
        LC.mobileCall(mobileCmd.closeFrame, { type: 1 })
      } else {
        LC.mobileCall(mobileCmd.closeFrame, { type: 2 })
      }
    }, 1000);
  })
}

//拿腾讯音乐人用户信息
window.$getUserStatus = function (callback, force) {
  if (!force && window.$userStatus) {
    callback && callback(window.$userStatus)
    return
  }
  e.emit('loading', true)
  window.$getUserInfo(({ userid, token }) => {
    window.$req('getUserStatus', {
      platformAccountId: userid,
      platformIdType: 2
    }).then(res => {
      e.emit('loading', false)
      // console.log(res)
      //这里后端改过接口，慎重处理，不改原组件处理逻辑，将内置status抽出来
      let data = res.data || {}
      let users = Array.isArray(data.users) ? data.users : []
      let findItem = users.find(ele => (ele.role === 1)||(ele.role === 2))
      data.accountStatus = data.status
      //外置对应音乐人的状态
      data.status = findItem ? findItem.status : 0 //0就是绑定无入驻状态

      // 黑名单和已注销直接覆盖
      if (data.delete) {
        data.status = 900
      } else if (data.black && data.status == 0) {//已入驻进入后台，未入驻成功被冻结的才进入审核结果页
        data.status = 901
      }
      // 状态50需要隐藏绑定入口
      if (~[50].indexOf(data.accountStatus) || ~[50].indexOf(data.status)) {
        window.$noBindDialog = true
      }
      window.$userStatus = data
      callback && callback(window.$userStatus, findItem || {})

    }).catch(rese => {
      e.emit('loading', false)
      if (rese && rese.code && rese.code > 1000000) {
        window.$userStatus = {
          status: rese.code
        }
        callback && callback(window.$userStatus)
      }else{
        setTimeout(() => {
          if (LC.isIOS) {
            LC.mobileCall(mobileCmd.closeFrame, { type: 1 })
          } else {
            LC.mobileCall(mobileCmd.closeFrame, { type: 2 })
          }
        }, 1000);
      }
    })

  })
}

function callLogin() {
  if(!window.__userStatusInit){
    window.__userStatusInit = true;
    LC.KgWebMobileCall("KgWebMobileCall.userStatus", function (res) {
      refreshPage()
    });
  }
  if (LC.isInClient()) {
    LC.mobileCall(mobileCmd.login, { topicName: window.document.title, loginType: null })
  } else {
    return openKugouApp("303", 9, 0, {
      url: window.location.href,
      title: document.title
    })
    /* window.location.href = "https://m3ws.kugou.com/loginReg.php?act=login&url=" +
      encodeURIComponent(window.location.href); */
  }
}
window.$callLogin = callLogin

window.helpAndFeedback = function() {
  openKf()
  /* LC.mobileCall(mobileCmd.openURL, {
    url: 'https://wenjuan.kugou.com/fb/app/home/100051'
  }) */
}
//客户端相关初始化
LC.mobileCall(mobileCmd.updateTitle, { title: document.title })
LC.mobileCall(mobileCmd.showHideBar, { state: 0 })
LC.mobileCall(mobileCmd.showRightMenus, {
  "list": [ {
    type:2
  },
  {
    type: 6,
    title: '在线客服',
    callbackName: 'helpAndFeedback()',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU0MTk3QUQ3N0Q2OTExRUE4QUM2OTZEREY1M0JCN0EyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU0MTk3QUQ4N0Q2OTExRUE4QUM2OTZEREY1M0JCN0EyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTQxOTdBRDU3RDY5MTFFQThBQzY5NkRERjUzQkI3QTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTQxOTdBRDY3RDY5MTFFQThBQzY5NkRERjUzQkI3QTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5Xi2CCAAACLUlEQVR42tSYO0sDQRSFsyqJBBOVIAimsBAUxD+glf4Ai2CjQRCsLBJb0UKwsbDVxk6wEAuNhaWFWKQQiXY+GkHSqAQxpghE17NwRjZLNpnZRxIvfCzJzL33sDtnshNN1/VAO0VHoM3i3wgKgjTIgiLQPaTIumn2qQ5jDVkYAjm9OZFjv7/+VjFBk5hHkADRGqLdEGXdR/a5BSE7QSlOegB9HguxYtS/Z7+UnaAsJyR8FiNIsF9WfKdZ9qEyF1ov+GyCqSLsY/TtruUyseplxUyCY5AHFfAGLsCS5JZS5DVk5zIRMrd7HXzXcdAJ0CTqVPV0Kmia8ypgG4yCTjAAFsE7x5ebJSjDeZs24wscv1QVZF3U4oPW4NkXQD+Ic/1YIwbewQfn1Yuqnl0O3bHGa95mvMRrWLWwU0H7DcaTvN4qV3bhMjtGQIF1ks1a1HaMgWfWOJW0faDej6sbQXOgaHJX2EkdrwQNgxJzD0CPgxrG3jbolaAd5h05vLsrzM94JeiGeTMOcme54/+Aea8E5VmwXzFvwrTuNvxwmQpx8MJ+h8KRrRIU5qurERd8dfbUZSp5xlvBGec/gZgftlfJ2+XcV+7qgVYKEvYugymZjbHMhKgP68Zs76TsTu3XqcOw95fZ3rKC0ky69/BcVtPesoJCJjuKk2vEpb3vatlbVpDbs720vVUEiTP+Krg2PXtVQXv17K0qyC3jjexth+bTX3rGCXgLXIFzlcRfAQYANJzrFsGrlAEAAAAASUVORK5CYII='
  } ]
})
LC.mobileCall(mobileCmd.setKeyboard, { type: 1 })

//页面跳转
window.$goToPage = function (url, title) {
  if (!LC.isInClient()) {
    window.location.href = url
    return
  }
  if (LC.isIOS) {
    LC.mobileCall(mobileCmd.openURL, { browser: 2, shownav: 1, hasBar: 0, url: url, title: title || '' })
  } else {
    LC.mobileCall(mobileCmd.openURL, { browser: 9, shownav: 1, hasBar: 0, url: url, title: title || '' })
  }
}

//路由监听
window.savePreRuturnCb = function () {
  let hash = window.location.hash
  
  if (hash !== '#/agreement' && (hash === '#/' || window.$toResultTag) || (hash === '#/enter-choose' && window.toClaim) || window.toBind) {
    if (LC.isIOS) {
      LC.mobileCall(mobileCmd.closeFrame, { type: 1 })
    } else {
      LC.mobileCall(mobileCmd.closeFrame, { type: 2 })
    }
  } else {
    e.emit('loading', false)
    e.emit('closeSelector', true)
    window.history.back()
  }
}
LC.mobileCall(mobileCmd.savePreReturnPage, { type: 3, cb: 'savePreRuturnCb' })

// history.listen((location, action) => {
// })

window.$toResultTag = false;
window.$checkIfToResult = function (callback) {
  let resultStatus = [
    10, 12, 13, 14, 16, 17,
    18, 19, 20, 22, 23, 24, 25, 70, 71, 72
  ]

  window.$getUserStatus(getStatusConfig => {
    let status = getStatusConfig.status
    //非注销机构
    let findItem = getStatusConfig.users && JSON.stringify( getStatusConfig.users ) !== '{}' && getStatusConfig.users.find( ele => ( ele.role === 2 ) && ( ele.status !== -1 ) );
    if ( findItem ){
      LC.mobileCall(mobileCmd.savePreReturnPage, { type: 0 })
      window.location.replace( 'https://activity.kugou.com/vo-activity/bd0c1520-722a-11ea-bd83-e73dc97ba287/index.html' )
      return;
    }
    /* 
      DJ身份、音乐人审核状态 -- Remix后台
      DJ审核状态 -- DJ审核状态页面
      音乐人审核状态 -- 音乐人审核状态页面
      音乐人、不管是否DJ -- 音乐人后台
      DJ/音乐人都在审核状态 --- 音乐人审核状态页面
    */
    
    // 入驻成功的，直接跳转去数据页
    if (~[1, 3, 4, 21, 31].indexOf(status)) {
      //透传所有url参数
      let params = getAllUrlParams();
      window.location.replace('https://h5.kugou.com/musicianService/v-6d9959c0/index.html?isHideTitleBar=1&type=1&norule=1'+(Object.keys(params).length?'&'+json2keyval(params):''))
      return;
    }

    // 初始化获取用户状态
    window.$getUserStatus()
    //初始化先基础配置
    getBaseConfig()
    //只有remix入驻成功的音乐人才能看到
    window.$getRemixStatus((json)=>{
      //已入驻Remix
      if(json.is_settle == 1){
        /* window.pushBI({
          a: 23298,
          ft: '差一步进入remix后台页面',
          r: '主页面'
        }, true) */
        callback && callback(true, status);
        //人脸识别返回的不作处理
        if(!getQueryString('FaceAuBack')){
          //remix音乐人直接跳转后台 http://mtp.kugou.net/clientmanage_v2/pmsedit_v2/?type=show_record&id=89072
          if(getQueryString('settleFromBackend')){
            if(getQueryString('toBind') || getQueryString('toClaim')){
              //App.js 处理
              callback && callback(false, status)
            }else{
              history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            }
          }else{
            let params = getAllUrlParams();
            window.location.replace('https://h5.kugou.com/musicianService/v-6d9959c0/index.html?isHideTitleBar=1&type=1&norule=1'+(Object.keys(params).length?'&'+json2keyval(params):''))
          }
        }
        
        //跳过Remix后台
        /* if(getQueryString('passRemixbackEnd')){
          let params = getAllUrlParams();
          window.location.replace('https://h5.kugou.com/musicianService/v-6d9959c0/index.html?isHideTitleBar=1&type=1&norule=1'+(Object.keys(params).length?'&'+json2keyval(params):''))
        }else{
          window.location.replace('#remix-backend')
        } */
      }else{
        //跳转音乐人审核状态页面
        if (getStatusConfig.delete || getStatusConfig.black || ~resultStatus.indexOf(status)) {
          callback && callback(true, status)
          window.$toResultTag = true
          let path = '/enter/' + window.encodeURIComponent(JSON.stringify({ status }))
          window.location.replace('#' + path)
          return;
        }

        //跳转remix审核状态页面
        if(json.audit_status != 0){
          //透传所有url参数
          let params = getAllUrlParams();
          window.location.replace('https://h5.kugou.com/apps/musician-dj-enter/build/index.html?t=1'+(Object.keys(params).length?'&'+json2keyval(params):'')+'/#/enter'+ window.encodeURIComponent(JSON.stringify({ status: json.info.review_status })))
        }else{
          //remix入驻返回
          if(localStorage.getItem("returnEnterPage")){
            history.go('/enter-choose')
            localStorage.removeItem("returnEnterPage")
            callback && callback(false, status)
          }else{
            callback && callback(false, status)
          }
        }
      }
    })
  })
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


// 加载bi脚本
setTimeout(function () {
  var ga = document.createElement("script");
  ga.type = "text/javascript";
  ga.async = true;
  ga.src =
    "https://staticssl.kugou.com/collect/common/dist/js/collect-2400.js?v=2";
  var s = document.getElementsByTagName("script")[0];
  ga.addEventListener("load", function () { }, false);
  s.parentNode.insertBefore(ga, s);
}, 200);

//兼容客户端ix
// var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
// var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
// var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
// if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
//   document.documentElement.style.minHeight = '104%'
//   document.body.style.minHeight = '104%'
// }